export function groupCollectionsBySourceType(collections = []) {
  const order = []; // keeps insertion order of sourceType keys
  const map = new Map(); // sourceType -> collection[]

  for (const collection of collections) {
    // Determine the dominant sourceType for this collection
    const firstSourceType =
      collection.endpoints?.find((ep) => ep.sourceType)?.sourceType ?? "Unknown Source";

    if (!map.has(firstSourceType)) {
      map.set(firstSourceType, []);
      order.push(firstSourceType);
    }

    map.get(firstSourceType).push(collection);
  }

  return order.map((sourceType) => ({
    sourceType,
    collections: map.get(sourceType),
  }));
}
